import tingle from 'tingle.js';
import 'tingle.js/dist/tingle.min.css';

// Create a global variable to keep track of the currently opened modal

function videoModal() {
    let currentModal = null;

    // Function to transform a video URL into an embeddable format
    function transformVideoUrl(videoUrl) {
        if (videoUrl) {
            if (videoUrl.includes('vimeo.com')) {
                // Extract the video ID from the Vimeo URL
                const vimeoVideoID = videoUrl.match(/\/(\d+)/)[1];
                // Construct the Vimeo embed URL
                return `https://player.vimeo.com/video/${vimeoVideoID}`;
            } else if (videoUrl.includes('youtube.com')) {
                // Extract the video ID from the YouTube URL
                const youtubeVideoID = videoUrl.match(/v=([^&]+)/)[1];
                // Construct the YouTube embed URL
                return `https://www.youtube.com/embed/${youtubeVideoID}`;
            } else if (videoUrl.includes('.mp4') || videoUrl.includes('.webm') || videoUrl.includes('.ogv')) {

            }
        }
        return videoUrl;
    }

    const videoControls = document.querySelectorAll('.u-video');
    videoControls.forEach(videoControl => {
        videoControl.addEventListener("click", (e) => {
            e.preventDefault();
            const videoUrl = videoControl.getAttribute('data-video-url');
            const transformedVideoUrl = transformVideoUrl(videoUrl); // Transform the URL

            // Check if there's an existing modal, destroy it before creating a new one
            if (currentModal) {
                currentModal.destroy();
                currentModal = null; // Clear the current modal reference
            }

            let modalContent;

            if (videoUrl.includes('vimeo.com') || videoUrl.includes('youtube.com')) {
                // Use iframe for Vimeo or YouTube URLs
                modalContent = `<iframe src="${transformedVideoUrl}" preload="auto" autoplay width="800" height="450" frameborder="0" allow="autoplay" allowfullscreen></iframe>`;
            } else {
                // Use HTML5 video element for other URLs
                const desiredWidth = 800;
                modalContent = `
                    <video preload="auto" controls autoplay width="${desiredWidth}" height="auto">
                        <source src="${transformedVideoUrl}" type="video/mp4">
                        Your browser does not support the video tag.
                    </video>
                `;
            }

            // Create a new tingle modal instance
            const modal = new tingle.modal({
                footer: false,
                stickyFooter: false,
                closeMethods: ['overlay', 'button', 'escape'],
                closeLabel: "Close",
                cssClass: ['custom-class-1', 'custom-class-2'],
                onOpen: () => {
                    // console.log('modal open');
                    // Change the width of the video iframe after the modal is opened
                    // const mediaIframe = document.querySelector('iframe[name="media"]');
                    // console.log(mediaIframe);
                    // if (mediaIframe) {
                    // 	mediaIframe.style.width = `100%`;
                    // }
                },
                onClose: () => {
                    currentModal = null; // Clear the current modal reference on modal close
                    // console.log('close');
                    modal.destroy();
                },
                beforeClose: function() {
                    // here's goes some logic
                    // e.g. save content before closing the modal
                    return true; // close the modal
                    return false; // nothing happens
                }
            });

            // Set the modal content
            modal.setContent(modalContent);

            // Open the modal
            modal.open();

            currentModal = modal;
        });
    });
}
videoModal();

//
// accordion
//
function accordion() {

    const accordions = document.querySelectorAll('.b-accordion__list');
    accordions.forEach(accordion => {



        const lists = accordion.querySelectorAll('li');


        // Open the first accordion item onload
        // if (lists.length > 0) {
        //     const firstList = lists[0];
        //     const firstText = firstList.querySelector('.answer');
        //     const firstHeight = firstText.scrollHeight;

        //     firstList.classList.add('active');
        //     firstList.setAttribute('aria-expanded', 'true');
        //     firstText.style.maxHeight = firstHeight + 'px';
        // }

        lists.forEach(list => {

            // console.log(list);

            const open = list.querySelector('.question');
            if (!open) {
                return;
            }

            open.addEventListener('click', (e) => {

                console.log('click');

                // Check if the clicked element is a button
                // if (e.target.tagName.toLowerCase() === 'button' && !e.target.classList.contains('question') || !e.target.classList.contains('question')) {
                if (e.target.classList.contains('answer')) {
                    // e.preventDefault();
                    return;
                }

				e.preventDefault();

                const text = list.querySelector('.answer');
                if (!text) {
                    return;
                }

                var height = text.scrollHeight;

                // Close other lists
                lists.forEach(otherList => {
                    if (otherList !== list) {
                        const otherText = otherList.querySelector('.answer');
                        if (otherText) {
                            otherText.style.setProperty('max-height', '0px');
                        }
                        // console.log(otherText.style);
                        otherList.classList.remove('active');
                        otherList.setAttribute('aria-expanded', 'false');
                    }
                });

                // Toggle current list
                var aria = list.getAttribute('aria-expanded') === 'true' ? 'false' : 'true';
                list.setAttribute('aria-expanded', aria);

                if (list.getAttribute('aria-expanded') === 'false') {
                    text.style.maxHeight = '0px';
                    list.classList.remove('active');
                    list.setAttribute('aria-expanded', 'false');
                } else {
                    text.style.maxHeight = height + 'px';
                    list.classList.add('active');
                    list.setAttribute('aria-expanded', 'true');
                }
            });
        });

    });
}
// document.addEventListener('load', accordion);
// document.addEventListener('DOMContentLoaded', accordion);
accordion();
